import { JetView } from 'webix-jet'; // Import core Webix-Jet class to define the view
import { countries, devConfig, profile } from 'config/config'; // Import configuration modules

export default class FilterPromotionalCodesView extends JetView {
    config() {
        const _ = this.app.getService('locale')._; // Get localization method
        const lang = this.app.getService('locale').getLang(); // Get current language from locale service

        // Left section of form with filters
        const left = {
            margin: 5,
            id: 'a9',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a9',
                    cols: [
                        {
                            view: 'text',
                            minWidth: 200,
                            name: 'UserId',
                            type: 'number',
                            label: "<span class='icon-drivers-license-o'></span>" + _('ID Usuario'),
                            hidden: !devConfig.getPermAction('filterByUser', 'Add'), // Hide if permission not granted
                            css: 'prm-filterByUser',
                            labelPosition: 'top',
                            placeholder: _('ID Usuario'),
                        },
                        {
                            view: 'text',
                            name: 'Datepicker',
                            id: 'Datepicker',
                            css: 'reportrange',
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Periodo evaluado'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                        },
                        {
                            view: 'datepicker',
                            name: 'Date',
                            id: 'Date',
                            stringResult: true, // Return as formatted string
                            minWidth: 200,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Periodo evaluado'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: moment().format('YYYY-MM-DD'), // Set current date as default
                            format: '%d %M %Y', // Display format for date
                            suggest: {
                                type: 'calendar',
                                body: { maxDate: new Date() }, // Restrict to today
                            },
                        },
                    ],
                },
            ],
        };

        // Section container
        const upper_section = {
            css: 'father-container',
            rows: [
                { margin: 10, cols: [left] }, // Embed left form
            ],
        };

        // Buttons row for first form
        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav', gravity: 4 }, // Spacer column
                        {
                            view: 'button',
                            value: _('Limpiar'),
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                this.getRoot().clear(); // Clear all form values
                            },
                        },
                        {
                            view: 'button',
                            value: _('Consultar'),
                            hotkey: 'enter',
                            type: 'form',
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            id: 'consultDesk',
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get all filter inputs
                                if (profile.typeDate !== 2) delete filterdata['Date']; // Conditional cleanup
                                else delete filterdata['Datepicker'];
                                this.app.callEvent('report:filter', [filterdata]); // Emit event for filtering
                                $$('b5').collapse(); // Collapse accordion
                            },
                        },
                    ],
                },
            ],
        };

        // Buttons for second popup form
        const buttons2 = {
            rows: [
                {
                    padding: 10,
                    cols: [
                        {
                            view: 'button',
                            value: _('Limpiar'),
                            click: () => { $$('myForm2').clear(); }, // Clear popup form
                        },
                        {
                            view: 'button',
                            value: _('Consultar'),
                            hotkey: 'enter',
                            type: 'form',
                            click: () => {
                                const filterdata = $$('myForm2').getValues(); // Get popup form values
                                if (profile.typeDate !== 2) delete filterdata['Date'];
                                else delete filterdata['Datepicker'];
                                this.app.callEvent('report:filter', [filterdata]); // Emit event
                            },
                        },
                    ],
                },
            ],
        };

        // Accordion layout for filters
        const accordion_section2 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true, // Start collapsed
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'),
                            id: 'b5',
                            body: { padding: 10, rows: [upper_section, buttons] },
                        },
                    ],
                },
            ],
        };

        // Scrollable section (used in popup)
        const accordion_section3 = {
            view: 'scrollview',
            scroll: 'xy',
            body: { padding: 10, rows: [upper_section] },
        };

        // Popup for filters in mobile/small screens
        const filterPopup = webix.ui({
            view: 'window',
            move: true,
            id: 'filterPopup',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Filtros'), align: 'center' },
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        click: function () { this.getTopParentView().hide(); }, // Close popup
                    },
                ],
            },
            modal: true, // Disable background interaction
            position: 'center',
            body: {
                view: 'form',
                id: 'myForm2',
                type: 'clean',
                rows: [accordion_section3, buttons2], // Add sections and buttons
                rules: { fname: webix.rules.isNotEmpty }, // Validation rule
            },
        });

        // Return main form structure
        return {
            view: 'form',
            type: 'clean',
            rows: [
                screen.width > 500 && screen.height > 500
                    ? accordion_section2 // Desktop view
                    : { height: 1, width: 0 }, // Placeholder for mobile
            ],
            rules: { fname: webix.rules.isNotEmpty },
        };
    }

    // Initialize lifecycle of view
    init(grid) {
        const lang = this.app.getService('locale').getLang(); // Get language again for modal
        $$('Datepicker').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang); // Set date modal configuration
        });

        webix.ready(function () {
            if (profile.typeDate !== 2) {
                $$('Date').hide(); // Hide specific field
                $$('Datepicker').show(); // Show alternative
            } else {
                $$('Date').show();
                $$('Datepicker').hide();
            }
        });
    }
}
